const modelNames = [
  'staffers',
]

const models = { }
modelNames.forEach(name => {
  models[name] = require(`./${name}.js`)
})

module.exports = models



// WEBPACK FOOTER //
// ./src/views/index.js